const FIELDS = [
  { key: "title", label: "Title" },
  { key: "event_date", label: "Date", type: "date" },
  { key: "location", label: "Place" },
  { key: "significant_people", label: "People who mattered" },
  { key: "description", label: "What happened", area: true },
  { key: "photo_reminder", label: "Photo reminder (text only)" },
];

const inputCls = "mt-1 w-full rounded-lg border border-[#4A4540]/15 bg-white px-3 py-2 text-[15px] text-[#2C2A28] outline-none focus:border-[#A84A32]";

export const MemoryEditForm = ({ draft, onChange }) => (
  <div data-testid="memory-edit-form" className="space-y-3">
    {FIELDS.map((f) => (
      <label key={f.key} className="block text-xs font-medium uppercase tracking-wide text-[#8A7F76]">
        {f.label}
        {f.area ? (
          <textarea data-testid={`edit-${f.key}`} rows={6} value={draft[f.key] || ""}
            onChange={(e) => onChange({ ...draft, [f.key]: e.target.value })} className={`${inputCls} normal-case tracking-normal`} />
        ) : (
          <input data-testid={`edit-${f.key}`} type={f.type || "text"} value={(draft[f.key] || "").slice(0, f.type === "date" ? 10 : undefined)}
            onChange={(e) => onChange({ ...draft, [f.key]: e.target.value })} className={`${inputCls} normal-case tracking-normal`} />
        )}
      </label>
    ))}
  </div>
);

export const EDITABLE_KEYS = FIELDS.map((f) => f.key);
